/* import __COLOCATED_TEMPLATE__ from './input-field.hbs'; */
import Component from '@glimmer/component';
import AutofocusModifier from 'sh-www/modifiers/autofocus';
import NoopModifier from 'sh-www/modifiers/noop';
import DidInsertModifier from '@ember/render-modifiers/modifiers/did-insert';

/** @class */
class GlmPrivateInput extends Component {
  get autofocusModifier() {
    return this.args.autofocus
      ? AutofocusModifier
      : NoopModifier;
  }

  get didInsertModifier() {
    return this.args.didInsert
      ? DidInsertModifier
      : NoopModifier;
  }
}

export default GlmPrivateInput;
